// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "f901a30ffd5f";
export const BUILD_VERSION_NUMBER = 12;
